// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"iw_a bhs_je","CommentListPlaceholder--Legacy":"iw_b bhs_qh bhs_vk"};